var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelefono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.021,
    height: 23.472,
    viewBox: "0 0 23.021 23.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1078",
    "data-name": "Trazado 1078",
    d: "M16.513,23.472a4.441,4.441,0,0,1-1.732-.346C6.106,19.468,2.013,12.033.344,7.925A4.652,4.652,0,0,1,1.365,2.878l2.3-2.3a2.081,2.081,0,0,1,2.874,0l4.594,4.593a2.035,2.035,0,0,1,0,2.874L9.8,9.378l4.107,4.369,1.38-1.38a2.081,2.081,0,0,1,2.874,0l4.265,4.264a2.036,2.036,0,0,1,0,2.874l-2.595,2.6a4.713,4.713,0,0,1-3.32,1.372M5.105,1.48a.53.53,0,0,0-.376.156l-2.3,2.3a3.151,3.151,0,0,0-.692,3.422C3.315,11.252,7.188,18.3,15.363,21.744a3.145,3.145,0,0,0,3.409-.7l2.6-2.6a.533.533,0,0,0,0-.753L17.1,13.427a.544.544,0,0,0-.752,0L13.875,15.9,7.712,9.345l2.363-2.362a.534.534,0,0,0,0-.753L5.481,1.636a.53.53,0,0,0-.376-.156",
    transform: "translate(0)",
    fill: "#242221"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefono);
export default __webpack_public_path__ + "static/media/telefono.93c45cc5f66c09fdeb36b18e59d0c924.svg";
export { ForwardRef as ReactComponent };